if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      //==============================================================================================================
      // START MTBD Customisation
      // Checks quantity vs quantity available at warehouse and/or at vendor if it's dropship/special order
      // puts some validations in to make sure we're not overselling products.
      const variantId = formData.get('id'); // Get the variant ID
      const quantity = formData.get('quantity'); // Get the quantity being added to the cart

      //console.log(`Variant ID: ${variantId}`);
      //console.log(`Quantity: ${quantity}`);

      // window.Mtbd.variants is a global variable populated by the mtbd-product.liquid template
      if (window.Mtbd && window.Mtbd.variants){
        const findVariant = window.Mtbd.variants.find(variant => variant.variantid == variantId);

        if (findVariant){
          if (findVariant.inventory_quantity > 0){
            if (findVariant.inventory_quantity < quantity){
              formData.set('quantity', findVariant.inventory_quantity.toString());
              this.handleErrorMessage(`Only ${findVariant.inventory_quantity} available.  These have been added to your cart.`)
            }
          } else {
            if (findVariant.dropship || findVariant.special_order){
              const voh = findVariant.voh;
              let vohQty = 0;
              if (voh && voh.length > 0) {
                for (let i = 0; i < voh.length; i++) {
                  if (
                      (findVariant.voh[i].type === "Dropship" && findVariant.dropship === true) ||
                      (findVariant.voh[i].type === "Special Order" && findVariant.special_order === true)
                  ) {
                    vohQty += findVariant.voh[i].qty;
                  }
                }
              }
              if (vohQty > 0 && vohQty < quantity){
                formData.set('quantity', vohQty.toString());
                this.handleErrorMessage(`Only ${vohQty} available.  These have been added to your cart.`)
              }
            }
          }
        }
      }
      // END MTBD Customisation
      //==============================================================================================================


      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cartNotification.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cartNotification.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        if (typeof errorMessage === 'object' && !Array.isArray(errorMessage)) {
          this.errorMessage.textContent = Object.values(errorMessage).join(', ');
        } else {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  });
}
